import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "", y = 32, once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-10% 0px" }}
      transition={{ duration: 0.8, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "", stagger = 0.08 }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-10% 0px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}
    >
      {children}
    </motion.div>
  );
}

export const item = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease } },
};

export function SectionHeading({ eyebrow, title, sub, light = false, align = "left", id }) {
  return (
    <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <p className={`eyebrow ${light ? "text-teal-300" : ""}`} data-testid={id ? `${id}-eyebrow` : undefined}>{eyebrow}</p>}
      <h2 className={`mt-4 text-3xl font-bold leading-[1.1] sm:text-4xl lg:text-5xl ${light ? "text-white" : "text-slate-900"}`} data-testid={id ? `${id}-title` : undefined}>{title}</h2>
      {sub && <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-slate-300" : "text-slate-600"}`}>{sub}</p>}
    </Reveal>
  );
}
